import React from "react";

import * as S from "./styles";

// Gera a imagem do QR Code a partir da URL (mesmo link do CTA, por nível do aluno).
const buildQrCodeSrc = (url) =>
  `https://api.qrserver.com/v1/create-qr-code/?size=300x300&margin=0&data=${encodeURIComponent(
    url
  )}`;

export const CouponBanner = ({ couponUrl, couponCode, couponDiscount }) => {
  const hasQrCode = Boolean(couponUrl);
  // Sem cupom (campanha encerrada): mantém o QR/CTA, mas sem citar cupom/desconto.
  const hasCoupon = Boolean(couponCode);

  return (
    <S.Banner>
      <S.Content>
        <S.Title>
          Parabéns por realizar mais um simulado, é com muito treino que você
          alcança uma nota excelente no Enem em 2026.
        </S.Title>
        <S.Subtitle>
          {hasCoupon
            ? "Nós preparamos um cupom de desconto especial para você!"
            : "As matrículas do Aprova ENEM 180 estão abertas!"}
        </S.Subtitle>
        {hasQrCode ? (
          <S.QrCode
            src={buildQrCodeSrc(couponUrl)}
            alt={hasCoupon ? "QR Code do cupom de desconto" : "QR Code da matrícula"}
            loading="lazy"
          />
        ) : (
          <S.QrCodePlaceholder />
        )}
        <S.Caption>
          {hasCoupon ? (
            <>
              Escaneie o QR Code ou insira o cupom [{couponCode}] para garantir{" "}
              <strong>{couponDiscount}</strong> no Aprova Total.
            </>
          ) : (
            <>
              Escaneie o QR Code para garantir sua vaga no Aprova Total.
            </>
          )}
          <br />
          <br />
          <em>Bons estudos!</em>
        </S.Caption>
      </S.Content>
    </S.Banner>
  );
};

export default CouponBanner;
